import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-signout',
  templateUrl: './signout.component.html',
  styleUrls: ['./signout.component.css']
})
export class SignoutComponent implements OnInit {

  constructor(
    private _msal: MsalService
  ) { }

  ngOnInit() {
    this._msal.logout();
    window.location.href = 'https://geoinsightsbtc.b2clogin.com/geoinsightsbtc.onmicrosoft.com/oauth2/v2.0/logout?p=b2c_1a_signup_signin&post_logout_redirect_uri=http://help.geoinsights.com'
  }
}



// WEBPACK FOOTER //
// ./src/app/components/signout/signout.component.ts